import React from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useSelector } from "react-redux";
import { changeClientPortalUserDetails, selectIsBusy, selectUserProfile } from "./UserProfileSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

const profileDetailsSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
});

const ProfileDetails: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const user = useSelector(selectUserProfile);
  const isBusy = useSelector(selectIsBusy);

  return (
    <Formik
      validationSchema={profileDetailsSchema}
      initialValues={user}
      onSubmit={(values) => {
        thunkDispatch(changeClientPortalUserDetails(values));
      }}
      enableReinitialize={true}
    >
      <Form>
        <div className="row align-items-end mb-6">
          <div className="col-12 col-md-10">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="row">
                  <div className="col-5">
                    <label htmlFor={"firstName"} className="form-label required">
                      First Name
                    </label>
                  </div>
                  <div className="col-7">
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <ErrorMessage name="firstName" />
                      </div>
                    </div>
                  </div>
                </div>
                <Field
                  data-test-id="profile-details-form__first-name-input"
                  name={"firstName"}
                  id={"firstName"}
                  placeholder={"John"}
                  className="form-control form-control-solid"
                />
              </div>
              <div className="col-12 col-md-4">
                <div className="row">
                  <div className="col-5">
                    <label htmlFor={"lastName"} className="form-label required">
                      Last Name
                    </label>
                  </div>
                  <div className="col-7">
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <ErrorMessage name="lastName" />
                      </div>
                    </div>
                  </div>
                </div>
                <Field
                  data-test-id="profile-details-form__last-name-input"
                  name={"lastName"}
                  id={"lastName"}
                  placeholder={"Smith"}
                  className="form-control form-control-solid"
                  required
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-2 mt-4 mt-md-0">
            <button
              data-test-id="profile-details-form__update-details-button"
              type="submit"
              className="cpl-btn cpl-btn-primary"
              disabled={isBusy}
            >
              {!isBusy && "Update details"}
              {isBusy && (
                <span className="indicator-progress" style={{ display: "block" }}>
                  Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default ProfileDetails;
